<div class="d-flex justify-content-center align-items-center w-100 h-100 logged-out-container">
  <div class="col-xl-4 col-md-6 col-10">
      <div class="card border-0 box-shadow rounded-0">
          <div class="card-header d-flex justify-content-center logo-bg align-items-center border-0 box-shadow">
            <img class="logo" src="assets/img/app/aladdin-icon-blue.png" title="Aladdin" />
          </div>
          <div class="card-body text-center pb-1">
              <h2>You have been logged out</h2>
              <div class="form-group mt-4">
                <a class="btn btn-lg btn-primary" [routerLink]="loginUrl" data-testid="logged-out-return-to-log-in">Return to Log In</a>
              </div>              
          </div>            
      </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/auth/logged-out/logged-out.component.html